import {memo} from "react";
import {Bar} from "@ant-design/charts";

const CommonCareerChart = memo(({data}) => {

    var config = {
        data: data,
        xField: 'amount',
        yField: 'career',
        seriesField: 'career',
        meta: {
            amount: {
                alias: 'จำนวนตำแหน่งงาน',
                formatter: (v) => `${v} คน`
            }
        },
        scrollbar: {
            type: 'vertical'
        },
        // legend: {
        //     layout: 'horizontal',
        //     position: 'bottom',
        //     flipPage: false
        // }
        legend: false
    };

    return <Bar {...config} />;
})

export default CommonCareerChart;
